import { Component, computed, input } from '@angular/core';
import { GraphComponent } from '../../../../../components/graph/graph.component';
import { ChartOptions, ChartType, Scale, TooltipItem } from 'chart.js';
import { getSeriesColor } from '../../../../../utils/color/color';

@Component({
  selector: 'app-analytics-bar-chart',
  imports: [GraphComponent],
  templateUrl: './analytics-bar-chart.component.html',
  styleUrl: './analytics-bar-chart.component.css',
})
export class AnalyticsBarChartComponent {
  public data = input<{ [date: string]: number } | undefined>();
  public dataOptions = input<{ label: string; unit?: string } | undefined>();
  public title = input<string>();
  protected graphData = computed(() => {
    const dataInput = this.data();
    if (!dataInput) return;
    const dataValues = Object.values(dataInput);
    return {
      datasets: [
        {
          data: dataValues,
          backgroundColor: dataValues.map((_, i) => getSeriesColor(i)),
        },
      ],
      labels: Object.keys(dataInput),
    };
  });

  public options = computed((): ChartOptions<ChartType> => ({
    maintainAspectRatio: false,
    scales: {
      y: {
        afterFit: (scale: Scale) => {
          scale.width = 50;
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: this.title(),
        align: 'start' as const,
      },
      tooltip: {
        callbacks: {
          label: (context: TooltipItem<ChartType>) => {
            const { label = '', unit = '' } = this.dataOptions() || {};
            const value = context.parsed.y;
            return `${label}: ${value}${unit}`;
          },
        },
      },
    },
  }));
}
